import useStyles from '../../../style/js-style/containers/administration/attributes/AttributesStyle';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { Context } from '../../../states/Store';
import { useQuery } from '../../../config/Config';
import i18next from 'i18next';
import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import EATabPanel from '../../../components/common/EATabPanel';
import { useHistory, useParams } from 'react-router';
import ContextModelTab from './ContexteModelTab';
import { getAdminSettingsBaseRoute } from '../../../components/admin-settings/AdminSettingsUtils';

const ContextConfiguration = () => {
  const {classes} = useStyles();
  const [state, ] = useContext(Context);
  const query = useQuery();
  const configParam = useMemo(() => parseInt(query.get("config")) || 0, [query]);
  const [selectedTab, setSelectedTab] = useState(configParam);
  const {accountId} = useParams();
  const history = useHistory();

  const getAccountId = useCallback(() => {
    return accountId || state.account?.id;
  }, [accountId, state.account]);


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    history.push(
      `/${getAccountId()}/${getAdminSettingsBaseRoute()}?tab=context&config=${newValue}`
    );
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Grid container justifyContent="space-evenly" spacing={0}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper elevation={0} style={{marginTop: "17px"}}>

            {/* Tabs */}
            <Box className={classes.tabsWrapper} sx={{borderBottom: 1, borderColor: 'divider'}}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="demandes tabs"
              >
                <Tab
                  label={i18next.t("adminSettings.demandesContextes")}
                  {...a11yProps(0)}
                  className={classes.tab}
                  style={{position: "relative", top: "12px"}}
                  //disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE_VALUE)}
                />
              </Tabs>
            </Box>

            <EATabPanel value={selectedTab} index={0} variant={"withoutBackground"}>
              <ContextModelTab/>
            </EATabPanel>

          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ContextConfiguration;